module.exports = __webpack_public_path__ + "img/3.74ec6bf2.png";